<template>
  <div>
    <div class="m-title">{{ conf.title || '无' }}</div>

    <div class="board-box" v-loading="loading">
      <select-range @range-change="rangeChange" />
      <div :id="chartId" class="chart1"></div>
    </div>
  </div>
</template>

<script>
import common from './mixins/common'

/**
 * 柱形图
 */
export default {
  mixins: [common],
  name: 'ChartBar4',
  props: {
    source: { type: String, default: '' },
    list: { type: Array },
  },
  data() {
    return {
      /**
       * 按时间显示同比环比，以那种格式单位
       * @type {day}
       */
      timeUnit: 'day',
      t_condition: {},
      h_condition: {},
      chartData: {},
    }
  },
  computed: {
    conf: function () {
      /**
       * 不同 source 下配置数据
       * - timeField 接口查询时间字段
       */
      const Map = {
        type: {
          title: '现场服务单类型数量环比和同比',
          fieldConf: { xField: 'WORK_ORDER_TYPE_DESC', timeField: 'YW_SERVICE_ORDER_CREATE_TIME' },
          triggerClick: function (data, params) {
            console.log('现场类型：', data)
          },
        },
        time: {
          title: '现场服务单数量环比和同比',
          fieldConf: { xField: 'YW_SERVICE_ORDER_CREATE_TIME', timeField: 'YW_SERVICE_ORDER_CREATE_TIME' },
          triggerLabel: true,
          triggerClick: true,
        },
      }

      return Map[this.source] || {}
    },
  },
  watch: {
    chartData: function () {
      this.updateChart()
    },
  },
  mounted: function () {
    this.getData()
  },
  methods: {
    updateChart: function () {
      let chartData = this.chartData,
        conf = this.conf

      let baseBar = {
        type: 'bar',
        emphasis: {
          focus: 'series',
        },
        // barWidth: '14'
        barMaxWidth: '14',
      }
      let options = {
        legend: {
          left: '12%',
          top: '27',
          data: ['同比', '当前数量', '环比'],
        },
        series: [
          { ...baseBar, itemStyle: { color: '#5BBAF9' }, yAxisIndex: 1, name: '同比', data: chartData.tRatio },
          { ...baseBar, itemStyle: { color: '#5B8FF9' }, yAxisIndex: 0, name: '当前数量', data: chartData.curNum },
          { ...baseBar, itemStyle: { color: '#51C495' }, yAxisIndex: 1, name: '环比', data: chartData.hRatio },
        ],
        xAxis: [
          {
            type: 'category',
            triggerEvent: conf.triggerLabel,
            boundaryGap: true,
            data: chartData.xAxis || [],
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '数量（个）',
            boundaryGap: [0.2, 0.2],
            min: 0,
            minInterval: 1,
            splitLine: { show: false },
            nameTextStyle: { padding: [0, 30, 0, 0] },
          },
          {
            type: 'value',
            name: '比率（%）',
            min: 0,
            // interval: 50,
            axisLabel: { formatter: '{value} %' },
          },
        ],
        dataZoom: {
          show: true,
          start: 0,
          // end: 50,
          end: (4 * 100) / chartData.xAxis.length,
          height: 15,
        },
        // grid: { right: 130 },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        toolbox: {
          show: false,
          feature: {
            dataView: { readOnly: false },
            restore: {},
            saveAsImage: {},
          },
        },
      }

      /** @type {import('echarts').ECharts} */
      let chartIns = this.chartIns
      chartIns && chartIns.setOption(options, true)
    },

    /**
     * 处理数据
     * @param {[]} list [tArr, cArr, hArr]
     */
    processList: function (list, tDiff) {
      let { xField } = this.conf.fieldConf,
        timeUnit = this.timeUnit,
        source = this.source
      function getCurx(v, tch) {
        let curX = v[xField]

        if (source === 'time') {
          let f = 'MM-DD'
          // if (timeUnit === 'month') f = 'MM'

          // 去年同期日期 / 本期日期 / 上个周期日期
          if (!tDiff) return moment(v[xField]).format(f)
          if (tch === 0) {
            return [
              moment(curX).format(f),
              moment(curX).add(1, 'year').format(f),
              moment(curX).add(1, 'year').subtract(tDiff, 'day').format(f),
            ].join('/')
          } else if (tch === 1) {
            return [
              moment(curX).subtract(1, 'year').format(f),
              moment(curX).format(f),
              moment(curX).subtract(tDiff, 'day').format(f),
            ].join('/')
          } else if (tch === 2) {
            return [
              moment(curX).add(tDiff, 'day').subtract(1, 'year').format(f),
              moment(curX).add(tDiff, 'day').format(f),
              moment(curX).format(f),
            ].join('/')
          }
        }

        return curX
      }

      let tRatio = [],
        curNum = [],
        hRatio = [],
        xAxis = []

      let t_categoryMap = {},
        c_categoryMap = {},
        h_categoryMap = {}

      list[0].map((v) => {
        let curX = getCurx(v, 0)
        if (!xAxis.includes(curX)) xAxis.push(curX)
        if (!t_categoryMap[curX]) t_categoryMap[curX] = []
        t_categoryMap[curX].push(v)
      })
      list[1].map((v) => {
        let curX = getCurx(v, 1)
        if (!xAxis.includes(curX)) xAxis.push(curX)
        if (!c_categoryMap[curX]) c_categoryMap[curX] = []
        c_categoryMap[curX].push(v)
      })
      list[2].map((v) => {
        let curX = getCurx(v, 2)
        if (!xAxis.includes(curX)) xAxis.push(curX)
        if (!h_categoryMap[curX]) h_categoryMap[curX] = []
        h_categoryMap[curX].push(v)
      })

      xAxis.map((curX) => {
        let t_n = (t_categoryMap[curX] || []).reduce((total, cur) => (total += 1), 0)
        let c_n = (c_categoryMap[curX] || []).reduce((total, cur) => (total += 1), 0)
        let h_n = (h_categoryMap[curX] || []).reduce((total, cur) => (total += 1), 0)

        tRatio.push(t_n ? (100 * (c_n - t_n)) / t_n : 100)
        curNum.push(c_n)
        hRatio.push(h_n ? (100 * (c_n - h_n)) / h_n : 100)
      })

      this.chartData = { xAxis, tRatio, curNum, hRatio }
    },

    /**
     * 获取数据
     * @param {import('./SelectRange.vue').IRange} range 选择日期、品牌、工程师
     */
    getData: function (range) {
      let condition = this.condition,
        t_condition = this.t_condition,
        h_condition = this.h_condition,
        /** @type {import('../index.vue').IRoleId} */
        roleId = this.roleId,
        { mock, timeField } = this.conf.fieldConf,
        source = this.source

      let diff = ''
      if (range) {
        if (range.type === 'date') {
          const tf = 'YYYY-MM-DD'
          // 当期数量
          let [start = '', end = ''] = range.data.current
          if (start === end) {
            // LIKE
            condition[`${timeField}:2`] = start + '%'
            t_condition[`${timeField}:2`] = moment(start).subtract(1, 'year').format(tf) + '%'
            h_condition[`${timeField}:2`] = moment(start).subtract(1, 'day').format(tf) + '%'
          } else {
            // <= 接口不包含此临界值，故需 +1 或者拼接时分秒
            end = moment(end).add(1, 'day').format(tf)

            condition[`${timeField}:5`] = start
            condition[`${timeField}:6`] = end
            // diff = moment(end).diff(start, 'day') + 1
            diff = moment(end).diff(start, 'day')

            t_condition[`${timeField}:5`] = moment(start).subtract(1, 'year').format(tf)
            t_condition[`${timeField}:6`] = moment(end).subtract(1, 'year').format(tf)
            h_condition[`${timeField}:5`] = moment(start).subtract(diff, 'day').format(tf)
            h_condition[`${timeField}:6`] = moment(end).subtract(diff, 'day').format(tf)
          }
          if (!start && !end) {
            delete condition[`${timeField}:2`]
            delete condition[`${timeField}:5`]
            delete condition[`${timeField}:6`]
          }
        }
      }

      let tableName = 'YW_SERVICE_ORDER_V1'
      let ps = [[], this.api.queryList(tableName, { p2: condition, p9: '' }, `${roleId}_${source}_chartBar4_c`), []]

      if (range && range.type === 'date') {
        ps[0] = this.api.queryList(tableName, { p2: t_condition, p9: '' }, `${roleId}_${source}_chartBar4_t`)
        ps[2] = this.api.queryList(tableName, { p2: h_condition, p9: '' }, `${roleId}_${source}_chartBar4_h`)
      }

      this.loading = true
      Promise.all(ps).then(
        (res) => {
          this.loading = false
          if (mock) {
            this.chartData = {
              xAxis: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
              tRatio: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],
              hRatio: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2],
              curNum: [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3],
            }
            return
          }

          this.processList(
            res.map((item) => item.result || []),
            diff
          )
        },
        (err) => (this.loading = false)
      )
    },
  },
}
</script>

<style lang="postcss"></style>



// WEBPACK FOOTER //
// src/components/viewBoard/components/ChartBar4.vue